export const toDoOperation = (account_address, token_address, deposit_address) => ({
  type: 'ADD_ADDRESS',
  account_address,
  token_address,
  deposit_address
});
